<template lang="html">
  <el-row class="p-bind container">
    <el-row class="login-wrap">
      <el-row class="bind-con">
        <el-row class="bind-header">
          <el-row class="bind-logo">
            <template v-if="logo_url">
              <img :src="logo_url" alt="" width="60px" class="logo">
            </template>
            <template v-else>
              <img src="../assets/logo-fw.svg" alt="" width="60px" class="logo">
            </template>
          </el-row>
          <template>
            <h2>{{ $t('pages.forgot_password.forgotPasswordTitle') }}</h2>
          </template>
        </el-row>

        <el-row class="bind-content">
          <el-row v-if="current_reset === 'reset_password_checked'">
            <span class="bind-success">
              <i class="el-icon-check"></i>
            </span>
            <p
              class="bind-text"
              v-html="$t('reset.email_sent_info_html', { app_name: this.confirmForm.app_name, email: this.confirmForm.email})">
            </p>
          </el-row>

          <el-row v-if="current_reset === 'reset_password'">
            <el-form
              :model="confirmForm"
              ref="confirmForm"
              :rules="rules"
              class="bind-form"
            >
              <el-form-item prop="app_name" :label="$t('common.application')">
                <el-input
                  v-model="confirmForm.app_name"
                  disabled
                />
              </el-form-item>
              <el-form-item prop="email" :label="$t('common.email')">
                <el-input
                  v-model="confirmForm.email"
                  :placeholder="$t('pages.forgot_password.emailPlaceholder')"
                  @keyup.enter.native="confirmRecover"
                />
              </el-form-item>
              <el-form-item class="bind-btns">
                <el-col>
                  <el-button
                    @click="confirmRecover"
                    type="primary">
                    {{ $t('common.sendResetPasswordEmail') }}
                  </el-button>
                </el-col>
              </el-form-item>
            </el-form>
          </el-row>
        </el-row>
      </el-row>
    </el-row>
  </el-row>
</template>

<script>
  export default {
    data() {
      /* eslint-disable */
      const ptn = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      const emailValidator = (rule, value, cb) => {
        if (!value || value.trim() === '') {
          cb(new Error(this.$t('rules.require_email')));
        } else if (!ptn.test(value)) {
          cb(new Error(this.$t('rules.email')));
        } else {
          cb();
        }
      };
      return {
        app_key: 'qZkZT5WZSdirdcL88wyRx5pN8tsyaqAi',
        logo_url: null,
        resetParams: {
          email: '',
          app_name: ''
        },
        confirmForm: {
          email: null,
          app_name: null,
        },
        rules: {
          email: [
            { required: false, validator: emailValidator },
          ],
        },
        current_reset: '',
        password_error: false,
        forbid: false,
      };
    },
    methods: {
      validateUrlQuery() {
        const query = this.$route.query;
        if (!query.app_key) {
          this.$message.error(this.$t('bind.invalid_app_key'));
        }
      },
      initQuery() {
        const args = this.$route.query;
        this.current_reset = 'reset_password';
        if (args) {
          const url = `/api/auth/app/${args.app_key}`;
          this.$http.get(url).then((res) => {
            console.log('res', res);
            if (res.body.ok) {
              this.updateConfirmParams(res.body.data);
              this.logo_url = res.body.data.logo_url;
            } else if (res.body.reason === 'invalid argument' && 'client_app_key' in res.body.data) {
              this.$message.error(this.$t('bind.invalid_app_key'));
            }
          });
        }
      },
      updateConfirmParams(data) {
        this.$nextTick(()=>{
          this.confirmForm.app_name = data.name;
        });
      },
      confirmRecover() {
        this.$refs.confirmForm.validate((valid) => {
          if (valid) {
            const params = {
              client_app_key: this.$route.query.app_key,
              email: this.confirmForm.email,
              callback_url: this.$route.query
            };
            if (this.$route.query.callback_url) {
              params['callback_url'] = this.$route.query.callback_url;
            }

            this.$http.post('/api/auth/recover_password', params)
              .then((res) => {
                  this.current_reset = 'reset_password_checked';
                  // const { err_code: errCode, reason } = res.body;
                  // if (errCode && reason) {
                  //   this.$message.error(reason);
                  // } else {
                  //   this.$message.error('Unknown. Please contact an administrator');
                  // }
              }).catch((res) => {
                this.$message.error('Unknown. Please contact an administrator!');
              });
          }
        });
      },
    },
    created() {
      console.log(process.env.NODE_ENV);
      this.validateUrlQuery();
      this.initQuery();
    },
  };
</script>



// WEBPACK FOOTER //
// ForgotPassword.vue?31c38e72